import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { Button } from 'primeng/button';
import { DFMCheck } from '../../../../models/dfm-check.model';
import { QuoteRevisionItem } from '../../../../models/quote-revision-item.model';
import { QuoteRevisionItemService } from '../../../services/quote-revision-item.service';
import { DfmCheckItemComponent } from '../../../shared/dfm-check-item/dfm-check-item.component';

@Component({
  selector: 'app-quote-revision-item-dfm-checks',
  imports: [Button, DfmCheckItemComponent],
  templateUrl: './dfm-checks.component.html',
})
export class QuoteRevisionItemDfmChecksComponent {
  readonly revisionItemService = inject(QuoteRevisionItemService);

  @Input({ required: true }) item!: QuoteRevisionItem;
  @Input() selectedCadObjectId: number | null = null;
  @Input() selectedDFMCheck: DFMCheck | null = null;
  @Output() selectedDFMCheckChange = new EventEmitter<DFMCheck | null>();

  get checks(): DFMCheck[] {
    return this.item.dfm_checks.filter(
      (check) =>
        this.selectedCadObjectId == null ||
        check.cad_object_id === this.selectedCadObjectId,
    );
  }

  toggle(check: DFMCheck): void {
    this.selectedDFMCheckChange.emit(
      this.selectedDFMCheck?.id === check.id ? null : check,
    );
  }

  refresh(): void {
    const cadObjectId =
      this.selectedCadObjectId ??
      this.item.cad_objects[0]?.id ??
      this.item.inherited_cad_objects[0]?.id;
    if (cadObjectId == null || this.item.material_id == null) {
      return;
    }
    void this.revisionItemService.rerunDfmChecks(
      cadObjectId,
      this.item.material_id,
    );
  }
}
